import { ClosingControlState } from "../types/closing-control.type";

/**
 * Bloqueia POST /pre-closing durante a transição de aprovação da negociação
 * para fechamento, evitando chamadas acidentais ao habilitar a guia.
 */
export const closingApprovalTransitionRef = { current: false };

export const INITIAL_CLOSING_CONTROL_STATE: ClosingControlState = {
  closingStatus: null,
  closingStatusLabel: null,
  canEditClosing: true,
  headerButton: null,
};
